import React from 'react'
import {
  Wrapper,
  FooterSection,
  FooterLinks,
  FooterLinksSocial,
  FooterLinkItem,
  BusinessToolsLinkItem,
  ConnectLinkItem,
  SocialMediaLinkItem,
  SocialMediaIcon,
  FooterLink,
  LinkHeader,
  ContentContainer,
} from './styled'

import Link from '../../atoms/Link/Link'

import footerLinks from './FooterLinks'

const Footer = () => {
  const {
    homeLinks,
    businessToolsLinks,
    aboutLinks,
    connectLinksNew,
    socialMediaLinks,
  } = footerLinks

  return (
    <Wrapper>
      <ContentContainer>
        <FooterSection>
          <FooterLinks order={2}>
            {homeLinks.map(footerLink => (
              <FooterLinkItem key={`${footerLink.label}-${Math.random()}`}>
                <Link
                  linkText={footerLink.label}
                  url={footerLink.url}
                  linkColor={footerLink.linkColor}
                  hoverColor={footerLink.hoverColor}
                />
              </FooterLinkItem>
            ))}
          </FooterLinks>

          <FooterLinks order={4}>
            <FooterLinkItem>
              <LinkHeader>Business Tools</LinkHeader>
            </FooterLinkItem>
            {businessToolsLinks.map(footerLink => (
              <BusinessToolsLinkItem
                key={`${footerLink.label}-${Math.random()}`}
              >
                <Link
                  linkText={footerLink.label}
                  url={footerLink.url}
                  linkColor={footerLink.linkColor}
                  hoverColor={footerLink.hoverColor}
                />
              </BusinessToolsLinkItem>
            ))}
          </FooterLinks>

          <FooterLinks order={3}>
            {aboutLinks.map(footerLink => (
              <FooterLinkItem key={`${footerLink.label}-${Math.random()}`}>
                <Link
                  linkText={footerLink.label}
                  url={footerLink.url}
                  linkColor={footerLink.linkColor}
                  hoverColor={footerLink.hoverColor}
                />
              </FooterLinkItem>
            ))}
          </FooterLinks>

          <FooterLinks order={1}>
            <FooterLinkItem>
              <LinkHeader>Connect</LinkHeader>
            </FooterLinkItem>

            {connectLinksNew.map(footerLink => (
              <ConnectLinkItem key={`${footerLink.label}-${Math.random()}`}>
                {footerLink.label}
                <br />
                {footerLink.emailAddress && (
                  <Link
                    linkText={footerLink.emailAddress}
                    url={`mailto:${footerLink.emailAddress}`}
                    linkColor={footerLink.linkColor}
                    hoverColor={footerLink.hoverColor}
                  />
                )}
                <br />
                {footerLink.telephone && (
                  <Link
                    linkText={footerLink.telephone}
                    url={`tel:${footerLink.telephone.replace(/\s/g, '')}`}
                    linkColor={footerLink.linkColor}
                    hoverColor={footerLink.hoverColor}
                  />
                )}{' '}
                <br />
                {footerLink.additionalText && (
                  <ConnectLinkItem>
                    <LinkHeader>
                      {footerLink.additionalText} <br />
                      <br />
                    </LinkHeader>
                  </ConnectLinkItem>
                )}
              </ConnectLinkItem>
            ))}
          </FooterLinks>

          <FooterLinksSocial>
            {socialMediaLinks.map(footerSocialLink => (
              <SocialMediaLinkItem
                key={`${footerSocialLink.label}-${Math.random()}`}
              >
                <FooterLink
                  href={footerSocialLink.url}
                  target="_blank"
                  rel="nofollow"
                >
                  <SocialMediaIcon src={footerSocialLink.icon} />
                </FooterLink>
              </SocialMediaLinkItem>
            ))}
          </FooterLinksSocial>
        </FooterSection>
      </ContentContainer>
    </Wrapper>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/components/element/Footer/Footer.js